import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { IconComponent } from '@shared/icon/icon.component';
import {
  MobileModalActionsComponent,
  MobileModalAdComponent,
  MobileModalBodyComponent,
  MobileModalComponent,
  MobileModalTitleComponent,
} from './mobile-modal.component';

/**
 * Модуль мобильных модальных окон.
 * ВНИМАНИЕ: Не импортируйте этот модуль в других модулях для избежания дублирования компонентов.
 * Используйте SharedModalModule вместо этого.
 */
@NgModule({
  declarations: [
    MobileModalComponent,
    MobileModalTitleComponent,
    MobileModalBodyComponent,
    MobileModalActionsComponent,
    MobileModalAdComponent,
  ],
  imports: [LocaleSharedModule, CommonModule, IconComponent],
  exports: [
    MobileModalComponent,
    MobileModalTitleComponent,
    MobileModalBodyComponent,
    MobileModalActionsComponent,
    MobileModalAdComponent,
  ],
  providers: [],
})
export class MobileModalModule {}
